import { SVGProps } from 'react';



function EyeIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16.776 10"
            width="1.677em"
            height="1em"
            {...props}
        >
            <path
                d="M8.388 0C5.183 0 2.276 1.754.131 4.6a.664.664 0 000 .793c2.145 2.852 5.051 4.605 8.257 4.605s6.112-1.754 8.257-4.6a.664.664 0 000-.793C14.5 1.754 11.593 0 8.388 0zm.23 8.521a3.528 3.528 0 113.291-3.291 3.531 3.531 0 01-3.291 3.291zm-.106-1.627a1.9 1.9 0 111.774-1.774 1.9 1.9 0 01-1.775 1.774z"
                fill="currentColor"
            />
        </svg>
    );
}

export default EyeIcon;
